import { CircularProgress, Box, Typography } from '@mui/material';
import { FC } from 'react';

interface LoadingStateProps {
  /** The street address being searched */
  addressLine1?: string;
  /** Optional custom loading message prefix. Defaults to "Finding all previous listings and tax records" */
  messagePrefix?: string;
  /** Optional custom spacing for top/bottom margins. Defaults to 2 (16px) */
  verticalSpacing?: number;
  /** Optional CircularProgress size in pixels. Defaults to 20 */
  loaderSize?: number;
}

const LoadingState: FC<LoadingStateProps> = ({
  addressLine1,
  messagePrefix = 'Finding all previous listings and tax records for',
  verticalSpacing = 2,
  loaderSize = 20,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        my: verticalSpacing,
        pl: 2,
      }}
    >
      <CircularProgress size={loaderSize} />
      <Typography>
        {messagePrefix} {addressLine1 && <i>{addressLine1}</i>}{' '}
        {!addressLine1 && ' this address.'}
      </Typography>
    </Box>
  );
};

export default LoadingState;
